import React from 'react'
import { Box, Checkbox, FormControlLabel, Grid, Typography, TextField } from '@material-ui/core'

function ViewBusinessform3() {
  const inputValues = [
    //    { label: '', value: profilePicture, name: 'profilePicture' },
    { label: 'Who can add employees to your company ', value: 'dummy' },
    { label: 'Who can upload and download bulk data ', value: 'dummy' },
    { label: 'Who can change the Attendance of employee ', value: 'dummy' },
    { label: 'Who can change the status of lead ', value: 'dummy' },
  ]

  return (
    <Grid lg={12} container>
      {inputValues.map((item, index) => (
        <Grid item lg={12}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px' }}>
            <Typography>{item.label}</Typography>
            <Typography>{item.value}</Typography>
          </div>
        </Grid>
      ))}
    </Grid>
  )
}

export default ViewBusinessform3
